import type { ActivityType } from '@ll-platform/frontend/core/analytics/events';
import {
  EventChannel,
  type TrackingEvent,
} from '@ll-platform/frontend/core/analytics/types';

export const activityTypeSegmentSeparator = '.';

export const buildEventName = (type: ActivityType, separator: string): string =>
  type.split(activityTypeSegmentSeparator).join(separator);

export const isEventOnChannel = (
  event: TrackingEvent,
  channelType: EventChannel,
  excludeAll = false,
) => {
  if (!excludeAll && event.channel === EventChannel.All) {
    return true;
  }

  return Array.isArray(event.channel)
    ? event.channel.includes(channelType)
    : event.channel === channelType;
};
